import React, { useState } from "react";
import { useBalanceStore } from "../../../_store/balanceStore";
import numeral from "numeral";
import { OPTIONS_TYPE_CAR, OPTIONS_TYPE_PLACE } from "../functions";
import { ICON_EDIT_PENCIL_SQUARE } from "../../../utils/useIcons";
import { PopupMain } from "../../../components/popup/PopupMain";

const ListInsurance = ({ InsuranceData = {}, showTotal = true }) => {
  const [openAlertSuccess, setOpenAlertSuccess] = useState({
    status: false,
    message: "",
    navigate: "",
  });

  if (
    InsuranceData?.expenses_insuarant_lifes?.length === 0 ||
    !InsuranceData?.expenses_insuarant_lifes
  ) {
    return <></>;
  }

  return (
    <div className="mb-1.5">
      <PopupMain
        open={openAlertSuccess.status}
        text={openAlertSuccess.message}
        img={false}
        onClick={() => {
          setOpenAlertSuccess({ status: false, message: "", navigate: "" });
        }}
      />
      <div className=" border-b border-gray60 pb-3 mb-3"></div>
      <div className="flex flex-col items-center gap-2.5">
        <div className="flex w-full items-center ">
          <div className="flex justify-between p-2 bg-secoundblue rounded-[10px] w-full text-sm text-mainblue font-medium">
            <div className="flex space-x-[10px] items-center">
              <button
                onClick={() => {
                  setOpenAlertSuccess({
                    status: true,
                    message: `หากต้องการแก้ไขข้อมูลกรมธรรม์สามารถแก้ไข/ลบ ได้ที่งบดุล ค่าใช้จ่ายคงที่`,
                    // navigate: "/",
                  });
                }}
              >
                <ICON_EDIT_PENCIL_SQUARE className={"mr-2 w-4 h-4"} />
              </button>
              <div>กรมธรรม์เลขที่</div>
            </div>
            <div>มูลค่าเวนคืน</div>
          </div>
        </div>
        <>
          <div className="w-full pb-2.5 border-b border-gray60">
            <div className="flex flex-col gap-1.5">
              {InsuranceData?.expenses_insuarant_lifes?.map((item, index) => {
                return (
                  <div className="flex flex-col">
                    <div
                      key={index}
                      className="flex justify-between items-center text-xs font-normal"
                    >
                      <div>{item?.insurance_policy_number} </div>
                      <div className="text-mainblue">
                        {numeral(item?.insurance_policy_cash_surrender).format(
                          "0,0"
                        )}{" "}
                        บาท
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </>
      </div>
    </div>
  );
};

export default ListInsurance;
